import type { LtlQuote } from '@shipstation/client-common/types/ltl';

export enum FreightQuoteTopicStatus {
  Idle = 'idle',
  Loading = 'loading',
  Ready = 'ready',
  Error = 'error',
}

export enum FreightQuoteErrorReason {
  Expired = 'expired',
  NoMatch = 'no-match',
  QuoteFailed = 'quote-failed',
}

export type FreightQuoteTopic = {
  status: FreightQuoteTopicStatus;
  bookableRate: LtlQuote | null;
  errorReason?: FreightQuoteErrorReason;
  /** Raw server or Pusher error text for `errorReason === FreightQuoteErrorReason.QuoteFailed`; undefined for other reasons. */
  errorMessage?: string;
};
